import React from 'react';
 import { CSSProperties } from 'react';

 interface NoCTECoursesProps {
  message?: string;
 }

 const styles: { [key: string]: CSSProperties } = {
  container: {
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center', // Center content horizontally
   backgroundColor: '#ffe6e6',
   borderRadius: '8px',
   padding: '5px', // Increased padding for more visual space
   marginBottom: '16px',
   border: '1px solid #ffb3b3',
  },
  iconContainer: {
   backgroundColor: '#ffb3b3',
   borderRadius: '50%',
   width: '40px', // Slightly smaller icon to match subheading feel
   height: '40px', // Slightly smaller icon
   display: 'flex',
   justifyContent: 'center',
   alignItems: 'center',
   marginRight: '12px', // Adjusted margin
  },
  exclamation: {
   color: '#800000',
   fontSize: '24px', // Adjusted size to match subheading feel
   fontWeight: 'bold',
  },
  message: {
   color: '#800000',
   fontSize: '20px', // Matches the subheading font size
   marginLeft: '8px', // Space between exclamation and text
  },
 };

 const NoCTECoursesMessage: React.FC<NoCTECoursesProps> 
      = ({ message = "There is no CTE course available for this school." }): 
      JSX.Element => {
  return (
   <div style={styles.container}>
    <p style={styles.message}>{message}</p>
   </div>
  );
 };

 export default NoCTECoursesMessage;